import React from 'react';

import { SearchActiveFacets as RSKSearchActiveFacets } from '@uncinc/react-searchkit';
import { SearchActiveFacetsProps } from '@uncinc/react-searchkit/dist/components/ActiveFacets';

import './style.scss';

const SearchActiveFacets: React.FC<SearchActiveFacetsProps> = (props) => {
  return (
    <RSKSearchActiveFacets {...props} />
  );
};

export default SearchActiveFacets;
